exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "region-selection-landing .main-content{padding-left:10%;padding-top:3%}region-selection-landing h2.subtitle{margin-bottom:2%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/regionSelectionLanding/regionSelectionLanding.scss
 ** module id = 74
 ** module chunks = 0
 **/